import React from "react";
import { convertGridToPixels } from "../../Pages/FlexibleLayout/utils";
import PositionedScreen from "../../Pages/FlexibleLayout/PositionedScreen";
import ChartPreview from "../BuilderComponents/Preview/ChartPreview";

const ChartBlockPreview = ({ actualConfig }) => {
  // const { allApplicationBlockData } = useAppBlocksContext();

  // if (!config || !config.id) {
  //   console.error("Invalid config provided to ChartBlockPreview", config);
  //   return <div>Error: Invalid configuration</div>;
  // }

  // const chart = allApplicationBlockData?.[config.id];

  // if (!chart) {
  //   console.error(`Chart data not found for config ID: ${config.id}`);
  //   return <div>Error: Chart data not found</div>;
  // }

  const { is_positioned_block, device, position_block_config, position_block_metadata } = actualConfig;

  if (!device) {
    console.error("Device type is missing in chart data", actualConfig);
    return <div>Error: Device type missing</div>;
  }

  try {
    if (device === "desktop") {
      if (is_positioned_block) {
        return (
          <div className="overflow_hidden">
            <PositionedScreen layoutConfig={position_block_config || []} type={"view"} />
          </div>
        );
      } else {
        return <ChartPreview data={actualConfig} />;
      }
    } else if (device === "mobile") {
      if (is_positioned_block) {
        const gridSize = position_block_metadata?.grid_size || 4;
        const totalGrid = position_block_metadata?.total_grid || 128;

        return (
          <PositionedScreen
            layoutConfig={convertGridToPixels(position_block_config || [], gridSize)}
            screenWidth={gridSize * totalGrid || 512}
            type={"view"}
          />
        );
      }
      return <ChartPreview data={actualConfig} />;
    }

    console.warn("Unknown device type encountered", device);
    return <div>Warning: Unknown device type</div>;
  } catch (error) {
    console.error("An error occurred while rendering ChartBlockPreview", error);
    return <div>Error: Failed to render chart preview</div>;
  }
};

export default ChartBlockPreview;
